import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Dashboard from 'components_new/pages/Dashboard'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Dashboard />}
        path={'/dashboards/:id'}
      />
      <Route path={'/dashboards*'}>
        <Redirect to="/resources" />
      </Route>
    </Switch>
  )
}

export default Routes
